import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';
import { ApartmentDTO, BadgeDTO, EntrancePlantDetailDTO } from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import plantsClient from '@/core/services/plants';
import DialogAddBadge from '../../../EntrancePlantBadges/DialogAddBadge/DialogAddBadge.vue';
import BadgeItem from '../../../EntrancePlantBadges/BadgeItem/BadgeItem.vue';
import DialogInfo from '@/views/components/DialogInfo/DialogInfo.vue';

@Options({
  name: 'BadgesSection',
  props: {
    editingApartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  watch: {
    'editingApartment.badgeList.length': function () {
      this.apartmentWasEdited();
    },
  },
  components: {
    BadgeItem,
    DialogAddBadge,
    DialogInfo,
  },
  emits: ['badge-edited', 'error-badge'],
})
export default class BadgesSection extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  editingApartment!: ApartmentDTO;
  noModification: ApartmentDTO = new ApartmentDTO();
  badge: BadgeDTO | null = null;
  isVisibleAddBadge = false;
  isVisibleMaxEntity = false;

  plantBadges: BadgeDTO[] = [];
  badgesList: BadgeDTO[] = [];

  disabled!: boolean;
  async fetchBadges() {
    this.plantBadges = await plantsClient.badgeAll(
      this.currentEntrancePlant.desktopId as number
    );
  }

  async mounted() {
    await this.fetchBadges();
    if (this.editingApartment.badgeList) {
      this.badgesList = this.editingApartment.badgeList.map(
        (badgeCode) => new BadgeDTO({ badgeCode })
      );
    }
    this.noModification = new ApartmentDTO(this.editingApartment);
  }

  get noBadgeText() {
    const textToSplit = this.$t('AppResourceEP.BadgesListEmptyMessage');
    const noBadgeTextLines = textToSplit.split('\n');
    return noBadgeTextLines;
  }

  addBadge(addedBadges: BadgeDTO[]) {
    addedBadges.forEach((badge) => this.badgesList.push(new BadgeDTO({badgeCode: badge.badgeCode})));
    this.editingApartment.badgeList = this.badgesList.map((badge) => badge.badgeCode!);
    this.plantBadges = [...this.plantBadges, ...this.badgesList];
  }

  removeBadge(badgeToRemove: BadgeDTO) {
    this.editingApartment.badgeList = this.editingApartment.badgeList!.filter(
      (badge) => badge !== badgeToRemove.badgeCode
    );
    this.badgesList = this.badgesList.filter(
      (badge) => badge !== badgeToRemove
    );
  }

  async handleAddBadgeResident() {
    if (this.editingApartment.badgeList!.length >= 10) {
      this.isVisibleMaxEntity = true;
    } else {
      this.isVisibleAddBadge = !this.isVisibleAddBadge;
    }
  }

  async handleMaxEntityDialog() {
    this.isVisibleMaxEntity = false;
  }

  apartmentWasEdited() {
    this.$emit('error-badge', false);
    this.$emit('badge-edited', this.badgeEdited());
  }

  badgeEdited() {
    const badgeEdit = this.editingApartment.badgeList!.length !== this.noModification.badgeList!.length ||
      this.editingApartment.badgeList!.some((badgeCode) => !this.noModification.badgeList!.includes(badgeCode));
    return badgeEdit;
  }
}

